import { baseFirmUrl } from 'common/config/urls';
import {
  FUND_INVESTMENTS_DOCUMENTS_SLUG,
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SLUG,
  FUND_INVESTMENTS_SLUG,
  FUND_INVESTMENTS_SUMMARY_SLUG,
} from 'pages/FundInvestments/common/constants';

// Paths
export const FUND_INVESTMENTS_PATH_TABLE_SLUG = ':tableSlugParam?';
export const FUND_INVESTMENTS_PATH_FIRM_SLUG = ':firmSlugParam';
export const FUND_INVESTMENTS_PATH_COMPANY_SLUG = ':companySlugParam';
export const FUND_INVESTMENTS_PATH = `/firms/${FUND_INVESTMENTS_PATH_FIRM_SLUG}/${FUND_INVESTMENTS_SLUG}/${FUND_INVESTMENTS_PATH_COMPANY_SLUG}/${FUND_INVESTMENTS_PATH_TABLE_SLUG}`;

// URLs
export const getBaseFundInvestmentsUrl = (firmSlug: string, fundInvestmentSlug: string) =>
  `${baseFirmUrl(firmSlug)}/${FUND_INVESTMENTS_SLUG}/${fundInvestmentSlug}`;

export const getFundInvestmentsSummaryUrl = (firmSlug: string, fundInvestmentSlug: string) =>
  `${getBaseFundInvestmentsUrl(firmSlug, fundInvestmentSlug)}/${FUND_INVESTMENTS_SUMMARY_SLUG}`;

export const getFundInvestmentsMarketAdjustmentUrl = (firmSlug: string, fundInvestmentSlug: string) =>
  `${getBaseFundInvestmentsUrl(firmSlug, fundInvestmentSlug)}/${FUND_INVESTMENTS_MARKET_ADJUSTMENT_SLUG}`;

export const getFundInvestmentsDocumentsUrl = (firmSlug: string, fundInvestmentSlug: string) =>
  `${getBaseFundInvestmentsUrl(firmSlug, fundInvestmentSlug)}/${FUND_INVESTMENTS_DOCUMENTS_SLUG}`;
